<div class="boxed experience">
  <div class="grid align-center align-spaced">
    <div
      class="back xs-3 m-3 l-4 flex-container align-center align-left pointer"
      [ngClass]="{ 'm-3': !priceActive }"
      [routerLink]="['/collections/collection-detail/' + collectionId]"
    >
      <div class="shrink margin-r-1">
        <img
          src="./assets/img/zurueck_collection.svg"
          style="width: 4rem; height: 2rem; transform: translateY(-1px)"
        />
      </div>
      <div class="shrink">
        <span class="show-for-m">{{ "add-to-cart.back" | i18next }}</span>
      </div>
    </div>
    <div
      class="back xs-3 m-3 l-4 flex-container align-center align-left pointer"
      [ngClass]="{ 'm-3': !priceActive }"
      routerLink="/search"
    >
      <div class="shrink margin-r-1">
        <img
          src="./assets/img/zurueck_Lupe.svg"
          style="width: 2rem; height: 2rem; transform: translateY(-1px)"
        />
      </div>
      <div class="shrink">
        <span class="show-for-m">{{ "search-results.results" | i18next }}</span>
      </div>
    </div>

    <div class="xs-6 m-6 l-4 last-el flex-container align-center align-spaced">
      <div class="counter shrink flex-container align-center">
        <div class="minus shrink pointer" (click)="quantityDown()">
          <svg
            id="Gruppe_331"
            data-name="Gruppe 331"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="14.295"
            height="4.742"
            viewBox="0 0 14.295 4.742"
          >
            <defs>
              <clipPath id="clip-path">
                <rect
                  id="Rechteck_113"
                  data-name="Rechteck 113"
                  width="14.295"
                  height="4.742"
                  fill="#333"
                />
              </clipPath>
            </defs>
            <g
              id="Gruppe_330"
              data-name="Gruppe 330"
              clip-path="url(#clip-path)"
            >
              <path
                id="Pfad_159"
                data-name="Pfad 159"
                d="M13.645,3.477H.65a.65.65,0,0,1,0-1.3h13a.65.65,0,0,1,0,1.3"
                transform="translate(0 1.265)"
                fill="#333"
              />
            </g>
          </svg>
        </div>
        <div class="count shrink">
          {{ quantity }}
        </div>
        <div class="plus shrink pointer" (click)="quantityUp()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="14.295"
            height="14.293"
            viewBox="0 0 14.295 14.293"
          >
            <defs>
              <clipPath id="clip-path">
                <rect
                  id="Rechteck_112"
                  data-name="Rechteck 112"
                  width="14.295"
                  height="14.293"
                  fill="#333"
                />
              </clipPath>
            </defs>
            <g
              id="Gruppe_328"
              data-name="Gruppe 328"
              clip-path="url(#clip-path)"
            >
              <path
                id="Pfad_158"
                data-name="Pfad 158"
                d="M13.645,6.5H7.8V.65a.65.65,0,1,0-1.3,0V6.5H.65a.65.65,0,0,0,0,1.3H6.5v5.847a.65.65,0,1,0,1.3,0V7.8h5.847a.65.65,0,0,0,0-1.3"
                transform="translate(0 0)"
                fill="#333"
              />
            </g>
          </svg>
        </div>
      </div>
      <div class="shrink add-to-cart-btn pointer" (click)="addToCart()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="27.288"
          height="30.499"
          viewBox="0 0 27.288 30.499"
        >
          <g
            id="Gruppe_326"
            data-name="Gruppe 326"
            transform="translate(0.329 0.322)"
          >
            <g id="Gruppe_327" data-name="Gruppe 327">
              <path
                id="Pfad_155"
                data-name="Pfad 155"
                d="M21.87,39.457H5.4A4.9,4.9,0,0,1,.553,33.84l2.53-17.192A1.69,1.69,0,0,1,4.755,15.2H22.519a1.69,1.69,0,0,1,1.672,1.444l2.53,17.192A4.9,4.9,0,0,1,21.87,39.457Z"
                transform="translate(-0.322 -9.779)"
                fill="none"
                stroke="#333"
                stroke-miterlimit="10"
                stroke-width="1"
              />
              <path
                id="Pfad_156"
                data-name="Pfad 156"
                d="M18.364,5.844a5.344,5.344,0,1,1,10.689,0"
                transform="translate(-11.811 -0.322)"
                fill="none"
                stroke="#333"
                stroke-miterlimit="10"
                stroke-width="1"
              />
              <path
                id="Pfad_157"
                data-name="Pfad 157"
                d="M23.157,9.993V5.844a5.344,5.344,0,1,1,10.689,0V9.993"
                transform="translate(-14.894 -0.322)"
                fill="none"
                stroke="#333"
                stroke-miterlimit="10"
                stroke-width="1"
              />
              <circle
                id="Ellipse_49"
                data-name="Ellipse 49"
                cx="0.45"
                cy="0.45"
                r="0.45"
                transform="translate(7.813 9.221)"
                fill="none"
                stroke="#333"
                stroke-miterlimit="10"
                stroke-width="1"
              />
              <circle
                id="Ellipse_50"
                data-name="Ellipse 50"
                cx="0.45"
                cy="0.45"
                r="0.45"
                transform="translate(18.502 9.221)"
                fill="none"
                stroke="#333"
                stroke-miterlimit="10"
                stroke-width="1"
              />
              <line
                id="Linie_50"
                data-name="Linie 50"
                x2="12.174"
                transform="translate(7.228 18.657)"
                fill="none"
                stroke="#333"
                stroke-miterlimit="10"
                stroke-width="1"
              />
              <line
                id="Linie_51"
                data-name="Linie 51"
                y2="12.174"
                transform="translate(13.315 12.57)"
                fill="none"
                stroke="#333"
                stroke-miterlimit="10"
                stroke-width="1"
              />
            </g>
          </g>
        </svg>
        <span class="show-for-m">{{ "add-to-cart.in-bag" | i18next }}</span>
      </div>
    </div>
    <!-- div class="xs-12 m-3 flex-container align-center align-right last-el" *ngIf="priceActive">
      <h2 class="shrink margin-r-2">{{'add-to-cart.sum' | i18next}}</h2>
      <div class="price">{{cartPrice}} €</div>
    </div -->
  </div>
</div>
